/**
 * background-interface.js
 * バッチなどのバックグラウンド処理関連APIのI/F定義
 */

// プロトタイプ宣言追加メソッド
import '@/hrm-frontend/modules/functions/prototype-extends'

/**
 * バックグラウンド処理関連APIのI/F定義クラス
 */
export default class BackgroundApiInterface {
  /**
   * コンストラクター
   */
  constructor () {
    // ペイロード要素
    this.PAYLOAD_ITEM = {
      // 処理種別
      EXECUTE_TYPE: 'execute-type',
      // データ
      DATA: 'data'
    }
    // 処理種別
    this.EXECUTE_TYPE = {
      // バッチタスク一時停止フラグ取得
      GET_BATCH_TASK_SUSPEND_FLAG: 'get-batch-task-suspend-flag',
      // バッチタスク一時停止設定
      BATCH_TASK_SUSPEND: 'batch-task-suspend',
      // バッチタスク一時停止解除
      BATCH_TASK_RESUME: 'batch-task-resume',
    }
    // バックグラウンドタスク種別
    // ※DBのフィールド名を使う
    this.TASK_TYPE = {
      // 媒体連携
      MEDIA_COOPERATION: 'media_cooperation',
      // 自動採用フロー
      AUTO_RECRUITMENT_FLOW_ACTION: 'auto_recruitment_flow_action',
    }
    this.REQUEST_COMPONENT_LIST = {
      MEDIA_COOPERATION_ITEM_MASTER_SETTING: 'MediaCooperationItemMasterSetting',
    }
    // ペイロード初期値
    this.payload = {
      // リクエスト種別
      [this.PAYLOAD_ITEM.REQUEST_TYPE]: '',
      // 処理種別
      [this.PAYLOAD_ITEM.EXECUTE_TYPE]: '',
      // データ
      [this.PAYLOAD_ITEM.DATA]: {}
    }
  }

  /**
   * バッチタスク一時停止対象タスクリスト取得
   * @param {String} taskList 要求元コンポーネント名
   * @returns タスクリスト
   */
  getTaskList (componentName) {
    try {
      let taskList = []
      if (componentName === this.REQUEST_COMPONENT_LIST.MEDIA_COOPERATION_ITEM_MASTER_SETTING) {
        taskList.push(this.TASK_TYPE.MEDIA_COOPERATION)
        taskList.push(this.TASK_TYPE.AUTO_RECRUITMENT_FLOW_ACTION)
        return taskList
      }
    } catch (error) {
      throw error
    }
  }
  /**
   * バッチタスク一時停止フラグ取得クエリパラメーター作成
   * @param {Array} taskList タスクリスト
   * @returns ペイロード
   */
  makeBatchTaskSuspendFlagGetParameter () {
    try {
      let queryParameter = ''
      // クエリパラメーターを作成
      queryParameter = '{0}={1}'.format(
        // 処理種別
        this.PAYLOAD_ITEM.EXECUTE_TYPE,
        // バッチタスク一時停止フラグ取得
        this.EXECUTE_TYPE.GET_BATCH_TASK_SUSPEND_FLAG
      )

      // クエリパラメーターを返す
      return queryParameter
    } catch (error) {
      throw error
    }
  }

  /**
   * バッチタスク一時停止設定ペイロード作成
   * @param {Array} taskList タスクリスト
   * @returns ペイロード
   */
  makeBatchTaskSuspendPayload (taskList) {
    try {
      // 処理種別：バッチタスク一時停止設定
      this.payload[this.PAYLOAD_ITEM.EXECUTE_TYPE] = this.EXECUTE_TYPE.BATCH_TASK_SUSPEND
      // リクエストデータ：自動再開間隔と対象タスクリスト
      this.payload[this.PAYLOAD_ITEM.DATA] = {
        // 自動再開間隔 (秒)
        auto_resume_time: 3600,
        // タスクリスト
        task_list: taskList
      }
      // ペイロードを返す
      return this.payload
    } catch (error) {
      throw error
    }
  }

  /**
   * バッチタスク一時停止解除ペイロード作成
   * @param {Array} taskList タスクリスト
   * @returns ペイロード
   */
  makeBatchTaskResumePayload (taskList) {
    try {
      // 処理種別：バッチタスク一時停止解除
      this.payload[this.PAYLOAD_ITEM.EXECUTE_TYPE] = this.EXECUTE_TYPE.BATCH_TASK_RESUME
      // リクエストデータ：対象タスクリスト
      this.payload[this.PAYLOAD_ITEM.DATA] = taskList

      // ペイロードを返す
      return this.payload
    } catch (error) {
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/background/background-interface.js